import { useState } from "react";
import { useAuth } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Users, Zap } from "lucide-react";

const LoginPage = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    
    setLoading(true);
    await login(username, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1557518016-ecc95498f641?crop=entropy&cs=srgb&fm=jpg&q=85')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#064E3B]/90 via-[#064E3B]/80 to-[#059669]/70"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-md animate-slide-up">
        <Card className="border-0 shadow-2xl bg-white/95 backdrop-blur-sm rounded-3xl overflow-hidden">
          <CardHeader className="text-center pb-2 pt-8">
            <div className="mx-auto w-16 h-16 bg-[#064E3B] rounded-2xl flex items-center justify-center mb-4 shadow-lg">
              <Zap className="w-8 h-8 text-[#BEF264]" />
            </div>
            <CardTitle className="text-3xl font-heading font-black text-[#064E3B] tracking-tight">
              Turf Tribe
            </CardTitle>
            <CardDescription className="text-slate-500 font-medium mt-2">
              Your friendship club expense manager
            </CardDescription>
          </CardHeader>
          
          <CardContent className="px-8 pb-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="username" className="text-slate-700 font-semibold">
                  Phone Number
                </Label>
                <Input
                  id="username"
                  data-testid="login-username-input"
                  type="text"
                  placeholder="Enter your phone number"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="h-12 bg-slate-50 border-slate-200 focus:border-[#064E3B] focus:ring-2 focus:ring-[#064E3B]/20 rounded-xl px-4 transition-all"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="password" className="text-slate-700 font-semibold">
                  Password
                </Label>
                <Input
                  id="password"
                  data-testid="login-password-input"
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-12 bg-slate-50 border-slate-200 focus:border-[#064E3B] focus:ring-2 focus:ring-[#064E3B]/20 rounded-xl px-4 transition-all"
                />
              </div>
              
              <Button
                type="submit"
                data-testid="login-submit-btn"
                disabled={loading || !username || !password}
                className="w-full h-12 bg-[#064E3B] hover:bg-[#065f46] text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all active:scale-[0.98]"
              >
                {loading ? (
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Signing in...</span>
                  </div>
                ) : (
                  "Login"
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
        
        {/* Footer */}
        <p className="text-center text-white/70 text-sm mt-6">
          © 2026 Turf Tribe • Pickleball & Friends
        </p>
        <p className="text-center text-white/60 text-xs mt-2">
          Powered by <a href="https://www.eiosys.com" target="_blank" rel="noopener noreferrer" className="text-[#BEF264] hover:underline">Eiosys Private Limited</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
